import { useEffect, useState } from "react";

/**
 * ▶️ **스트립을 움직여 보여준다** — 네 칸이 이어진 그림을 제자리에서 재생.
 *
 * 캔버스가 아니라 **배경 위치를 옮긴다.** 캔버스로 그리면 다른 출처 그림에서 캔버스가
 * 오염돼(taint) 나중에 읽지 못하고, 굳이 그럴 이유도 없다.
 *
 * 🔴 **만든 결과는 눈으로 보여줘야 한다.** [🎬 걷게 만들기]를 누르면 그림 자리가 조용히
 * 채워질 뿐이라, 운영자에게는 「아무 변화가 없다」로 보인다 — 실제로 그런 신고를 받았다.
 * 걷는 그림은 **움직여 봐야** 잘 됐는지 알 수 있으니 정지 썸네일로는 모자란다.
 */
export function StripPlay({ url, fps = 8, size = 72 }: { url: string; fps?: number; size?: number }) {
  const [n, setN] = useState(0);
  const [i, setI] = useState(0);

  useEffect(() => {
    let alive = true;
    const img = new Image();
    img.onload = () => alive && setN(Math.max(1, Math.round(img.width / img.height)));
    img.src = url;
    return () => {
      alive = false;
    };
  }, [url]);

  useEffect(() => {
    if (n < 2) return;
    // 움직임을 줄여 달라고 한 분에게는 첫 칸만 보여준다(시각 안전 · 불변식 6).
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
    const t = window.setInterval(() => setI((v) => (v + 1) % n), 1000 / Math.max(0.2, fps));
    return () => window.clearInterval(t);
  }, [n, fps]);

  return (
    <span
      className="stripplay"
      style={{
        width: size,
        height: size,
        backgroundImage: `url(${url})`,
        backgroundSize: `${Math.max(1, n) * 100}% 100%`,
        backgroundPosition: n > 1 ? `${(i / (n - 1)) * 100}% 0` : "0 0",
      }}
    />
  );
}
